/*
 *
 * PrivacyConsentsModal
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 26-Mar-2025
*/

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from '../../modules/languageModule'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import PortalRadioBox from '@nexidigital/portalradiobox'

import './PrivacyConsentsModal.scss'

const PrivacyConsentsModal = (props) => {
  const [submitFetching, setSubmitFetching] = useState(false)
  const [selections, setSelections] = useState({
    commercialConsent: props.userConsents.consent3Value !== undefined ? (props.userConsents.consent3Value ? 'Yes' : 'No') : 'Yes',
    improveServiceConsent: props.userConsents.consent4Value !== undefined ? (props.userConsents.consent4Value ? 'Yes' : 'No') : 'Yes',
    thirdPartsConsent: props.userConsents.consent5Value !== undefined ? (props.userConsents.consent5Value ? 'Yes' : 'No') : 'Yes'
  })

  useEffect(() => {
    if (props.isLoading === false && submitFetching) {
      props.actions.doHidePopup()
      setSubmitFetching(false)
    }
  }, [props.isLoading])

  const handleSelectionChange = (consentKey, value) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      [consentKey]: value
    }))
  }

  const handleSubmit = () => {
    const mappedSelections = {
      consent3Value: selections.commercialConsent === 'Yes',
      consent4Value: selections.improveServiceConsent === 'Yes',
      consent5Value: selections.thirdPartsConsent === 'Yes'
    }

    props.actions.doUpdateConsents(mappedSelections)
    setSubmitFetching(true)
  }

  return (
    <MerchantModal
      onClose={() => props.actions.doHidePopup()}
      primaryAction={handleSubmit}
      primaryButtonLabel={formattedMessage.confirm}
      long
      title={formattedMessage.modalPrivacyModalTitle}
      primaryButtonLoading={props.isLoading}
    >
      <div className='privacyConsentsModal'>
        <MerchantFlowCard
          title={formattedMessage.modalPrivacyModalMerchantFlowCardTitle}
          subtitle={formattedMessage.modalPrivacyModalMerchantFlowCardDescription}
        >
          <div className='privacyConsents'>
            <div>
              <h3 className='privacyTitle'>{formattedMessage.consent1}</h3>
              <p className='privacySubtitle'>{formattedMessage.consent1Subtitle}</p>
              <PortalRadioBox
                radioGroupName='commercialConsent'
                id='commercialConsent'
                defaultValue={props.userConsents.consent3Value !== undefined ? (props.userConsents.consent3Value ? 'Yes' : 'No') : 'Yes'}
                onChange={(value) => handleSelectionChange('commercialConsent', value)}
                options={[
                  {
                    label: formattedMessage.yes,
                    value: 'Yes',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.yes}, ${formattedMessage.consent1Subtitle}`
                  },
                  {
                    label: formattedMessage.no,
                    value: 'No',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.no}, ${formattedMessage.consent1Subtitle}`
                  }
                ]}
                row
              />
            </div>
            <div>
              <h3 className='privacyTitle'>{formattedMessage.consent2}</h3>
              <p className='privacySubtitle'>{formattedMessage.consent2Subtitle}</p>
              <PortalRadioBox
                radioGroupName='improveServiceConsent'
                id='improveServiceConsent'
                defaultValue={props.userConsents.consent4Value !== undefined ? (props.userConsents.consent4Value ? 'Yes' : 'No') : 'Yes'}
                onChange={(value) => handleSelectionChange('improveServiceConsent', value)}
                options={[
                  {
                    label: formattedMessage.yes,
                    value: 'Yes',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.yes}, ${formattedMessage.consent2Subtitle}`
                  },
                  {
                    label: formattedMessage.no,
                    value: 'No',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.no}, ${formattedMessage.consent2Subtitle}`
                  }
                ]}
                row
              />
            </div>
            <div>
              <h3 className='privacyTitle'>{formattedMessage.consent3}</h3>
              <p className='privacySubtitle'>{formattedMessage.consent3Subtitle}</p>
              <PortalRadioBox
                radioGroupName='thirdPartsConsent'
                id='thirdPartsConsent'
                defaultValue={props.userConsents.consent5Value !== undefined ? (props.userConsents.consent5Value ? 'Yes' : 'No') : 'Yes'}
                onChange={(value) => handleSelectionChange('thirdPartsConsent', value)}
                options={[
                  {
                    label: formattedMessage.yes,
                    value: 'Yes',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.yes}, ${formattedMessage.consent3Subtitle}`
                  },
                  {
                    label: formattedMessage.no,
                    value: 'No',
                    tabIndex: 0,
                    'aria-label': `${formattedMessage.no}, ${formattedMessage.consent3Subtitle}`
                  }
                ]}
                row
              />
            </div>
          </div>
        </MerchantFlowCard>
      </div>
    </MerchantModal>
  )
}

PrivacyConsentsModal.propTypes = {
  isLoading: PropTypes.bool,
  actions: PropTypes.object,
  userConsents: PropTypes.object
}

PrivacyConsentsModal.defaultProps = {
  isLoading: false,
  actions: {},
  userConsents: {}
}

export default PrivacyConsentsModal
